module.exports = __webpack_public_path__ + "img/img_banner_heike.ff3ee881.png";